import React from 'react';
import BannerNoInstalacion from '../../layouts/BannerNoInstalacion';

const CaracteristicasGeneralesSpcPremium = () => {
  return (
    <section className="p-0 position-relative overflow-visible">
      <div className="container-fluid px-xxl-7">
        <div className="why-choose-style2 bg-dark rounded">
          <div className="row align-items-center align-content-center">
            <div className="col-lg-6 order-2 order-lg-1">
              <div className="mb-4 title-style5">
                <span className="sub-title">Ideal para cocinas, gimnasios y hospitales</span>
                <h2 className="display-5 font-weight-800 text-white mb-0 lh-1">
                Ventajas del Piso SPC Luxury
                </h2>
              </div>
              <p className="mb-3 text-white opacity7 w-xl-90 w-xxl-80">
              Es la alternativa de diseño más duradera y estable a los pisos laminados tradicionales. Su núcleo rígido de Stone Plastic Composite (SPC) garantiza un rendimiento superior frente al desgaste, superando la clasificación de uso residencial y comercial.
              </p>
              <p className="mb-0 text-white opacity7 w-xl-90 w-xxl-80">
                Gracias a su durabilidad y resistencia, el piso SPC Luxury es ideal para entornos que requieren higiene y alta exigencia como hospitales, veterinarias, oficinas y zonas de alto tráfico. La instalación se simplifica asegurando un ensamble firme y de larga vida útil. Algunas de sus principales ventajas son:
              </p>

            </div>
            <div className="col-lg-6 order-1 order-lg-2 mb-1-9 mb-md-2-5 mb-lg-0">
              <div className="why-choose-img1">
                <img src="/assets/img/productos/pisos-spc-premium/spc-luxury-ven.jpeg" alt="Ventajas Piso SPC Luxury" className="rounded" />
              </div>
            </div>
          </div>

          {/* Tarjetas */}
          <div className="row pb-2-5 pb-lg-7 pt-1-9 pt-lg-5 mt-n1-9 border-bottom border-color-light-white-fifty why-choose-dots position-relative">
            <Tarjeta
              imgSrc="/assets/img/icons/icon-67.png"
              titulo="Tecnología Patentada"
              descripcion="Sistema de ensamble reconocido que asegura una instalación más firme, y duradera, evitando filtraciones y desplazamientos."
              delay="200ms"
            />
            <Tarjeta
              imgSrc="/assets/img/icons/icon-67.png"
              titulo="Núcleo Rígido"
              descripcion="Su composición SPC de alta densidad garantiza resistencia superior frente a la humedad, haciéndolo ideal para baños y cocinas."
              delay="400ms"
            />
            <Tarjeta
              imgSrc="/assets/img/icons/icon-67.png"
              titulo="Resistencia al impacto"
              descripcion="Clasificado para uso residencial y comercial, ofrece gran estabilidad dimensional, junto con alta resistencia a impactos y rayaduras."
              delay="600ms"
            />
            <Tarjeta
              imgSrc="/assets/img/icons/icon-67.png"
              titulo="Diseño y Conforte Acústico"
              descripcion="Acabados modernos y elegantes con apariencia realista, que además ofrecen una sensación confortable y un excelente aislamiento acústico."
              delay="800ms"
            />
          </div>

          {/* Sección final */}
          <div className="row mt-2-0 mt-lg-5 align-items-center position-relative z-index-9">
            <div className="col-lg-8 mb-1-9 mb-lg-0">
              <div className="text-start">
                <h3 className="mb-0 text-white h4">
                Te asesoramos en tu proyecto. ¡Cuéntanos qué superficie deseas cubrir!</h3>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="text-start text-lg-end">
                <a href="contacto-decototal" className="butn-style7 secondary medium rounded">
                Contáctanos ahora
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Componente para las tarjetas
const Tarjeta = ({ imgSrc, titulo, descripcion, delay }) => {
  return (
    <div className={`col-md-6 col-xl-3 mt-1-9 wow fadeInUp`} data-wow-delay={delay}>
      <div className="card card-style22 border-0 bg-transparent">
        <div className="h-100">
          <div className="card-img">
            <img src={imgSrc} alt="..." className="w-60px" />
          </div>
          <div className="card-title">
            <h3 className="text-white h4">{titulo}</h3>
          </div>
          <p className="mb-0 text-white opacity7">{descripcion}</p>
        </div>
      </div>
    </div>
  );
};

export default CaracteristicasGeneralesSpcPremium;
